<script>
import AddUserModal from "@/view/components/accounts/AddUserModal.vue";
import UpdateUserModal from "@/view/components/accounts/UpdateUserModal.vue";
import { removeUser } from "@/api/accounts.js";
import DataTableSection from "@/view/components/helper/datatable/datatableSingleFetch.vue";

export default {
  name: "users",
  components: {
    AddUserModal,
    UpdateUserModal,
    DataTableSection
  },
  data() {
    return {
      search: "",
      selected: [],
      items: [],
      item: null,
      snackbar: false,
      dialogRemove: false,
      dialogMsg: "",
      update: false,
      tableDataParam: {
        getters: 'getUsers',
        dispatchFunction: 'getUsers',
        headers: [
          {
            text: "Name",
            align: "left",
            sortable: true,
            value: "profile.name"
          },
          { text: "Email", value: "profile.email" },
          { text: "Phone Number", value: "profile.phone_number" },
          { text: "Company Name", value: "profile.company_name" },
          { text: "Action", value: "action",sortable: false }
        ]
      },
      customRenderers: [
        {
          field: "profile.name",
        },
        {
          field: "action",
        }
      ] 
    };
  },
  async mounted() {
  },
  computed: {
    searchTrigger() {
      console.log('SEARCH--==',this.search);
      return this.search;
    }
  },
  watch: {
    searchTrigger(q) {
        let componentEvent = this.$refs.dataTableComponent
        componentEvent.updateSearchField(q)
    }
  },
  methods: {
    handleModalClose() {
      this.update = false;
    },
    showUpdateUserModal(item) {
      // console.log(item);
      this.item = [];
      this.update = false;
      this.update = true;
      this.item = item;
    },
    async emailRemove(item) {
      this.item = item;
      this.dialogMsg = `Remove ${item.profile.name} ?`;
      this.dialogRemove = true;
    },
    async removeConfirm() {
      let item = this.item;
      this.item = null;
      this.dialogRemove = false;
      await removeUser(item.id);
      this.$store.dispatch("getUsers");
    },
    closeDelete() {
      this.item = null;
      this.dialogRemove = false;
    }
  }
};
</script>

<template>
  <v-card>
    <v-row class="mb-5">
      <v-col cols="12" md="8">
        <v-btn class="ml-4" depressed tile v-b-modal.modal-add-user>
          <v-icon left> mdi-plus-box </v-icon> Add User
        </v-btn>
      </v-col>
      <v-col cols="12" md="4">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <b-icon icon="search"></b-icon>
            </div>
          </div>
          <b-form-input v-model="search" placeholder="Search"></b-form-input>
        </div>
      </v-col>
    </v-row>

    <data-table-section
        :tableData="this.tableDataParam"
        :customRenderers="this.customRenderers"
        :isSelectEnabled="false"
        :setPerPage="5"
        ref="dataTableComponent"
      >
      <template v-slot:profile.nameparams="{ item }">
        <v-btn
          text
          color="primary"
          @click="showUpdateUserModal(item)"
          v-b-modal.modal-update-user
        >
          {{ item.profile.name }}
        </v-btn>
      </template>
      <template v-slot:actionparams="{ item }">
        <a href="#" v-if="!item.default" @click.prevent="emailRemove(item)">
          Delete
        </a>
      </template>
    </data-table-section>

    <add-user-modal></add-user-modal>
    <update-user-modal
      v-if="update"
      @close="handleModalClose"
      :item="item"
    ></update-user-modal>
    <v-dialog v-model="dialogRemove" max-width="510px">
      <v-card>
        <v-card-title class="headline">{{ dialogMsg }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="removeConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<style>
  .v-data-footer{
    justify-content: flex-end;
  }

  .v-menu__content {
    position: absolute;
    display: inline-block;
    max-width: 80%;
    overflow-y: auto;
    overflow-x: hidden;
    contain: content;
    will-change: transform;
    -webkit-box-shadow: 0 5px 5px -3px rgb(0 0 0 / 20%), 0 8px 10px 1px rgb(0 0 0 / 14%), 0 3px 14px 2px rgb(0 0 0 / 12%);
    box-shadow: 0 5px 5px -3px rgb(0 0 0 / 20%), 0 8px 10px 1px rgb(0 0 0 / 14%), 0 3px 14px 2px rgb(0 0 0 / 12%);
    border-radius: 4px;
  }
</style>